import { render, staticRenderFns } from "./UserOvpJobConditionsExport.vue?vue&type=template&id=2b9b5d20&"
import script from "./UserOvpJobConditionsExport.vue?vue&type=script&lang=js&"
export * from "./UserOvpJobConditionsExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports